import http from 'utils/httpClient';
const path = '/warranty-dismantle';
export const loadDismantleOptions = () => http.get(`${path}/options`);
export const loadDismantles = params => http.get(path, { params });
export const loadDismantle = id => http.get(`${path}/${id}`);
export const saveDismantleConfig = body => http.post(`${path}/configuration`, body);
export const findDismantleSources = params => http.get(`${path}/sources`, { params });
export const findDismantleProducts = params => http.get(`${path}/products`, { params });
export const createDismantle = body => http.post(path, body);
export const actOnDismantle = (id, action, body) => http.post(`${path}/${id}/${action}`, body);
export const loadDismantleCosts = id => http.get(`${path}/${id}/cost-options`);
